const en = {
  _code: "en",
  Event0: "",
  Event1: "",
  Event2: "Panic alert",
  Event3: "Ignition ON",
  Event4: "Ignition OFF",
  Event5: "Opened door",
  Event6: "Closed door",
  Event7: "Opened valve",
  Event8: "Closed valve",
  Event9: "Over speed limit",
  Event10: "Low battery (external)",
  Event11: "Requires communication",
  Event12: "Battery disconnected",
  Event13: "Battery reconnected",
  Event14: "Car tow alert",
  Event15: "Idle",
  Event16: "Tractor cage connected",
  Event17: "Tractor cage disconnected",
  Event19: "Opened hood",
  Event20: "Closed hood",
  Event21: "Delivered",
  Event22: "Not delivered",
  Event23: "Low battery (internal)",
  Event30: "Energy saving",
  Event33: "Jamming",
  Event34: "Tamper ON",
  Event35: "Tamper OFF",
  Event36: "Mixing",
  Event37: "Unload",
  Event43: "Side door opened",
  Event44: "Side door closed",
  Event47: "Internal battery connected",
  Event48: "Internal battery disconnected",
  Event50: "Normal temperature",
  Event51: "Low temperature",
  Event52: "High temperature",
  Event53: "Normal pressure",
  Event54: "Low pressure",
  Event55: "High pressure",
  Event56: "Normal level",
  Event57: "Low level",
  Event70: "Idle begin",
  Event71: "Idle end",
  Event101: "Thermo ON",
  Event102: "Thermo OFF",
  Event103: "Rear door opened",
  Event104: "Rear door closed",
  Event105: "Fuel load",
  Event106: "Fuel discharge",
  Event107: "Fuel transer",
  Event108: "Fuel sensor (1) ON",
  Event109: "Fuel sensor (1) OFF",
  Event110: "Fuel sensor (2) ON",
  Event111: "Fuel sensor (2) OFF",
  Event120: "Service",
  Event130: "Speeding start",
  Event131: "Speeding end",
  Event133: "Intense acceleration",
  Event134: "Intense braking",
  Event136: "Sharp turn",
  Event137: "Dangerous curve",
  Event139: "Impact",
  Event140: "Collision",
  Event142: "Excess of continuous driving time",
  Event143: "Driving after hours: start",
  Event144: "Driving after hours: end",
  Event159: "DTC deleted",
  Event160: "DTC detected",
  Event161: "Out of range (RPM)",
  Event162: "Out of range (Odometer)",
  Event163: "Out of range (Fuel - upper limit)",
  Event164: "Out of range (Fuel - lower limit)",
  Event165: "Out of range (Throttle position)",
  Event166: "Out of range (Antifreeze temperature)",
  Event167: "Out of range (Horometer)",
  Event254: "Still accumulated time",

  Month1: "January",
  Month2: "February",
  Month3: "March",
  Month4: "April",
  Month5: "May",
  Month6: "June",
  Month7: "July",
  Month8: "August",
  Month9: "September",
  Month10: "October",
  Month11: "November",
  Month12: "December",

  Day1: "Sunday",
  Day2: "Monday",
  Day3: "Tuesday",
  Day4: "Wednesday",
  Day5: "Thursday",
  Day6: "Friday",
  Day7: "Saturday",

  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",

  CombustibleCalculadoPorUnidad: "Fuel consumption estimate graph",
  CombustibleCalculado: "Fuel consumption estimate",
  RalentiPorFlota: "Idle by fleet",
  Minutos: "Minutes",
  EstadoDeIgnicion: "Ignition status",
  Encendidas: "On",
  Apagadas: "Off",
  EstadoDeMovimiento: "Moving status",
  Detenidas: "Stopped",
  ProximoRecordatorio: "Next reminder",
  SinDatosAMostrar: "No data",
  RangoDeConsulta: "Request range",
  IntervaloDeActualizacion: "Update interval",
  ActualizacionManual: "Manual update",
  Ajustes: "Settings",
  SinOrdenesDeTrabajo: "No work orders to show",
  OrdenesDeTrabajo: "Work orders",
  Activas: "Active",
  Inactivas: "Inactive",
  Neutral: "Neutral",
  EstadoDeConectividad: "Conection status",
  Valor: "Value",
  Grafica: "Graph",
  Seleccionadas: "Selected",
  NoSeleccionadas: "No selected",
  SemanaEnCurso: "Current week",
  SemanaPasada: "Last week",

  AceleracionIntensa: "Intense acceleration",
  AceleracionesIntensas: "Intense accelerations",
  Anio: "Year",
  Anterior: "Previous",
  AperturaPuertaLateral: "Side door openings",
  AperturaPuertaPrincipal: "Rear door openings",
  AplicarLimites: "Save",
  Atajo: "Shortcut",
  Ayer: "Yesterday",
  BateriaVehiculo: "Vehicle battery",
  CambiarIdioma: "Cambiar idioma a Español (MX)",
  CambiarRangos: "Set up ranges",
  CambiarUnidadTemperaturaA: "Change temperature unit to ",
  Cancelar: "Close",
  Cantidad: "Value",
  CantidadDeServicios: "Services",
  Cargando: "Loading",
  CargasCombustible: "Loads",
  CargasYDescargasFuel: "Loads and unloads",
  CiclosRefrigeracion: "Cooling cycles",
  Ciudad: "City",
  Cliente: "Client",
  ClientesVisitados: "Visited clients",
  Codigo: "Code",
  CodigosError: "Error codes",
  Colision: "Collision",
  Colisiones: "Collisions",
  Combustible: "Fuel",
  CombustibleConsumido: "Consumed fuel",
  CombustibleDesviado: "Deflected fuel",
  CombustibleConsumidoDesviado: "Consumed/deflected fuel",
  CombustibleRalenti: "Iddle fuel",
  CombustibleInicial: "Initial fuel",
  CombustibleFinal: "Final fuel",
  CombustibleUtilizado: "Fuel used",
  ComportamientoGeneral: "General behavior",
  ConfiguracionDriving: "Driving configuration",
  ConfigurarValores: "Set values",
  ConfigurarRangosTemperatura: "Set up ranges",
  Consultar: "Search",
  ConsultaRapida: "Quick search",
  Consumo: "Consumption",
  ConfiguracionGuardada: "Configuration saved",
  CostoDelCombustible: "Fuel price",
  Costo: "Cost",
  De: "of",
  DescargarComo: "Save as...",
  DescargasCombustible: "Unloads",
  Descripcion: "Description",
  DescripcionPorUnidad: "Description by unit",
  Descuento: "Discount",
  Desgaste: "Wear",
  Desviacion: "Deviation",
  Detalles: "Details",
  Detenido: "Detenido",
  Direccion: "Address",
  Distancia: "Distance",
  DistanciaRecorrida: "Traveled distance",
  DistribucionEventos: "Events distribution",
  ErrorAlConsultarDatos: "There was an error loading the data",
  ErrorAlAplicarRangos: "There was an error when applying the ranges",
  ErrorAlRestablecerRangos: "There was an error when restoring the ranges",
  ErrorAlGuardarConfiguracion:
    "There was an error when saving the configuration",
  Evento: "Event",
  Eventos: "Events",
  EventosDeServicio: "Service events",
  EventosDriving: "Trip events",
  ExcesoVelocidad: "Speeding",
  ExcesosVelocidad: "Speedings",
  Fecha: "Date",
  FechaFinal: "End date",
  FechaInicial: "Start date",
  Fin: "End",
  FrenadoIntenso: "Intense braking",
  FrenadosIntensos: "Intense brakings",
  Fuga: "Leak",
  GiroBrusco: "Sharp turn",
  GirosBruscos: "Sharp turns",
  GraficaDeTemperaturas: "Temperatures chart",
  GraficaDeEventos: "Events chart",
  Guardar: "Save",
  Historial: "History",
  Hoy: "Today",
  Icono: "Icon",
  Impacto: "Impact",
  Impactos: "Impacts",
  Inicio: "Start",
  InicioHome: "Home",
  IntervalosFueraRango: "Out of range intervals",
  Kilos: "Kilograms",
  KilosDespachados: "Kilograms served",
  KilosLitrosDespachados: "Total served",
  LimiteInferior: "Lower limit",
  LimiteSuperior: "Upper limit",
  Litros: "Liters",
  LitrosDespachados: "Liters served",
  LimiteCgu: "Limit",
  LogOut: "Logout",
  Mapa: "Map",
  Marca: "Make",
  Maxima: "Maximum",
  Mediana: "Median",
  MejorCliente: "Best customer",
  Minima: "Minimum",
  Modelo: "Model",
  Movimiento: "Moving",
  Muybien: "Good job!",
  Ninguno: "None",
  Nombre: "Name",
  NoSeEncontraronResultados: "No data found",
  Odometro: "Odometer",
  Pagina: "Page",
  Personalizada: "Custom",
  Ponchaduras: "Punctures",
  PosicionAcelerador: "Throttle position",
  PrecioPorLt: "Price per liter",
  PresionAceite: "Oil pressure",
  PresionAlta: "High pressure",
  PresionBaja: "Low pressure",
  Promedio: "Average",
  Puntos: "Points",
  PuntuacionPorUnidad: "Points by unit",
  Ralenti: "Idling",
  Rendimiento: "Performance",
  RendimientoBruto: "Brute performance",
  RendimientoEfectivo: "Effective performance",
  ReporteFinal: "Last report",
  ReporteInicial: "Initial report",
  ReporteRendimiento: "Performance",
  Rango: "Range",
  RangosDeTemperaturaAplicados: "The ranges have been applied",
  RangosDeTemperaturaRestablecidos: "The ranges have been restored",
  RangoMaximoMayorARangoMinimo: "Upper limit must be greater than lower limit",
  Restablecer: "Reset",
  Resultados: "results",
  Resumen: "Summary",
  ResumenComportamientoCombustible: "Fuel behavior summary",
  RestablecerRangos: "Restore ranges",
  Riesgo: "Risk",
  SemanaEnCurso: "Current week",
  Sensores: "Sensors",
  SeleccioneAlMenosUnaUnidad: "Please select at least one unit",
  Servicios: "Services",
  Siguiente: "Next",
  SinEventosDriving: "No events in this trip",
  TemperaturaAceite: "Oil temperature",
  TemperaturaAnticongelante: "Antifreeze temperature",
  TemperaturaCabina: "Cabin temperature",
  TemperaturaMaxima: "Maximum temperature",
  TemperaturaMinima: "Minimum temperature",
  TemperaturaPromedio: "Average temperature",
  TermosEncendidos: "Thermo ON",
  Tiempo: "Time",
  TiempoEnRefrigeracion: "Cooling time",
  TiempoFueraRango: "Time out of range",
  TiempoMovimiento: "Time moving",
  TiempoMuerto: "Dead time",
  TipoUnidad: "Unit type",
  Total: "Total",
  TotalServicios: "Total services",
  TotalVenta: "Sales total",
  Trayecto: "Journey",
  Trayectos: "Journeys",
  Ultimos30Dias: "Last 30 days",
  Unidad: "Unit",
  UnidadConMasServicios: "Unit with Most Services",
  UnidadConMenosServicios: "Unit with Least Services",
  UnidadEstacionaria: "Stationary unit",
  UnidadDeNoConsumo: "No consume unit",
  UnidadRegularDeConsumo: "Regular consume unit",
  Unidades: "Units",
  Usuario: "User",
  Valor: "Value",
  ValoresPorDefecto: "Default values",
  Velocidad: "Speed",
  VelocidadMaxima: "Max speed",
  VelocidadMotor: "Engine speed",
  VelocidadPromedio: "Average speed",
  VelocidadVehiculo: "Vehicle speed",
  VentasConDescuento: "Discount sales",
  Volumen: "Volume",

  AppDashboard: "Dashboard",
  AppFuel: "Fuel",
  AppGas: "Gas",
  AppDriving: "Driving",
  AppTemp: "Temp",
  AppScan: "Scan"
};

export default en;



// WEBPACK FOOTER //
// ./src/lang/en.js